import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.applications', {
        url: '/applications',
        component: 'companyApplicationsList',
        resolve: {applications},
    });
}

/** @ngInject */
function applications(ApplicationsResource, companyId) {
    return ApplicationsResource.getAllApplicationsForCompany(companyId)
        .then(apps => {
            apps
                .filter(app => app.publicService)
                .filter(app => app.publicService.slug === 'other')
                .forEach(app => app.publicService.serviceName = 'Custom');
            return apps;
        })
        .then(apps => apps.map(app => Object.assign(app, {
            samlAppLogo: window.env.urls.samlAppLogo(app.slug, 'thumb')
        })))
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/added-applications-list/added-applications-list.state.js